import {bookingEngineDashboard} from "../../../../constants/BookingEngine/bookingEngineDashboard.constants";

const initialState = {
    fetching : false,
    status : false,
    bookingEngineData : [],
    error : '',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case bookingEngineDashboard.BOOKING_ENGINE_DASHBOARD_PENDING:
            return {
                ...state,
                fetching: true,
                status: false,
            };
        case bookingEngineDashboard.BOOKING_ENGINE_DASHBOARD_FULFILLED:
            return {
                ...state,
                fetching: false,
                status: true,
                bookingEngineData: action.payload.data,
            };
        case bookingEngineDashboard.BOOKING_ENGINE_DASHBOARD_REJECTED:
            return {
                ...state,
                error: action.payload,
                fetching: false
            };
        case "CLEAR_STATE" :
            return {
                ...initialState
            }
        default:
            return state
    }
}
